import React from 'react';

function RgpdPage() {
    return (
        <div className="container">
            <h1>Politique de confidentialité et de protection des données</h1>
            <p>Nous prenons très au sérieux la confidentialité et la sécurité des données de nos visiteurs. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations personnelles lorsque vous visitez notre site web.</p>

            <h2>Informations personnelles collectées</h2>
            <p>Nous ne collectons des informations personnelles que lorsque vous nous les fournissez volontairement, par exemple lorsque vous remplissez notre formulaire de contact. Les informations que nous recueillons peuvent inclure votre nom, prénom, adresse e-mail et numéro de téléphone.</p>

            <h2>Finalité de la collecte des données</h2>
            <p>Nous utilisons les informations personnelles que vous nous fournissez uniquement dans le but de traiter vos demandes de contact.</p>

            <h2>Consentement</h2>
            <p>En soumettant notre formulaire de contact, vous consentez à la collecte et à l'utilisation de vos informations personnelles telles que décrites dans cette politique de confidentialité.</p>

            <h2>Stockage et sécurité des données</h2>
            <p>Nous cryptons les données que nous collectons et les stockons sur des serveurs sécurisés pour protéger leur confidentialité et leur intégrité.</p>

            <h2>Partage d'informations</h2>
            <p>Nous ne partageons pas vos informations personnelles avec des tiers.</p>

            <h2>Droits des visiteurs</h2>
            <p>Vous avez le droit d'accéder, de rectifier ou de supprimer vos informations personnelles. Pour exercer ces droits, veuillez nous contacter à l'adresse contact@adlagencedigitale.fr.</p>

            <h2>Cookies et technologies de suivi</h2>
            <p>Nous n'utilisons pas de cookies ou d'autres technologies de suivi sur notre site web.</p>

            <h2>Violation de données</h2>
            <p>En cas de violation de données, nous vous informerons par e-mail dans les plus brefs délais.</p>

            <h2>Utilisateurs mineurs</h2>
            <p>Notre site web n'est pas destiné aux utilisateurs mineurs et nous ne collectons pas intentionnellement d'informations personnelles les concernant.</p>
        </div>
    );
}

export default RgpdPage;
